import Vue from "vue";
import axios from "axios";
import Cookies from "js-cookie";
import router from "@/router";
import { Message } from "element-ui";

Vue.prototype.$httpUrl = process.env.VUE_APP_BASE_URL;

// Vue.prototype.$axios = axios
export const httpAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

httpAxios.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    console.log(err);
    Message({
      message: "系统错误，请联系管理员！",
      type: "error",
      duration: 3 * 1000
    });
    return Promise.reject(err);
  }
);

httpAxios.interceptors.response.use((response) => {
  console.log(response, 'response===')
  if (response.status == 200) {
    if (response.data.status == "-1") {
      Message({
        message: response.data.detail,
        type: "error",
        duration: 3 * 1000
      });
      return Promise.reject(response.data.detail);
    }
    if (response.data.status == "-100") {
      router.push({
        path: process.env.VUE_APP_LOGIN_PATH
      });
      return response;
    }
  }
  return response;
});

export const httpAuthAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

httpAuthAxios.interceptors.request.use(
  (config) => {
    if (Cookies.get("Admin-Token") && Cookies.get("Admin-Token") != "") {
      config.headers.Authorization = Cookies.get("Admin-Token");
    }
    return config;
  },
  (err) => {
    console.log(err, 'err===');
    Message({
      message: "系统错误，请联系管理员！",
      type: "error",
      duration: 3 * 1000
    });
    return Promise.reject(err);
  }
);

httpAuthAxios.interceptors.response.use((response) => {
  if (response.status == 200) {
    if (response.data.status == "-1") {
      Message({
        message: response.data.detail,
        type: "error",
        duration: 3 * 1000
      });
      return Promise.reject(response.data);
    }
    if (response.data.status == "-100") {
      router.push({
        path: process.env.VUE_APP_LOGIN_PATH
      });
      return response;
    }
  }
  return response;
});
